import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Skeleton, Stack } from "@mui/material";
import { Box } from "@mui/system";

interface Props {
  /** how many placeholder rows to draw - matches the chosen rows per page */
  rows?: number;
}

const COLUMN_COUNT = 6;

/** Placeholder that mirrors ByInterfaceTable while the interface coverage is loading. */
const ByInterfaceTableSkeleton = ({ rows = 10 }: Props) => {
  return (
    <>
      <TableContainer>
        <Table size="small" sx={{ whiteSpace: "nowrap" }}>
          <TableHead>
            <TableRow>
              {Array.from({ length: COLUMN_COUNT }).map((_, index) => (
                <TableCell key={index} align="left">
                  <Skeleton width={90} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "& > *": {
                    borderBottom: "1px solid rgba(224, 224, 224, 1) !important",
                  },
                }}
              >
                {Array.from({ length: COLUMN_COUNT }).map((__, cellIndex) => (
                  <TableCell key={cellIndex} align="left">
                    <Skeleton width="70%" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack
        spacing={1}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ padding: "12px 16px" }}
      >
        <Box sx={{ flex: 1 }}>
          <Skeleton width={140} height={24} />
        </Box>
        <Skeleton width={220} height={24} />
        <Box sx={{ flex: 1 }} />
      </Stack>
    </>
  );
};

export default ByInterfaceTableSkeleton;
